import LoyaltyPageReport from './LoyaltyPageReport';

export default LoyaltyPageReport;
